import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const SkeletonLoader = ({ count, loading, width, height }) => {
    return <Skeleton count={count} loading={loading} width={width} height={height} />
}

export default SkeletonLoader